import { Node, NodeProps } from "@xyflow/react";
import { ZapNodeData, ZapMetadata } from "@zapier/canvas-state";
import {
  DEFAULT_ZAP_NODE_BACKGROUND_COLOR,
  DEFAULT_ZAP_NODE_COLOR,
} from "@zapier/canvas-constants";

import { AssetNodeSkeleton } from "../AssetNodeSkeleton";

interface ZapNodeContentProps {
  className: string;
  zap?: ZapMetadata;
  isZapNotFound?: boolean;
  onUpdateNode?: (
    data: Partial<ZapNodeData>,
    options?: { shouldSave: boolean },
  ) => void;
  children?: React.ReactNode;
  isViewOnlyMode?: boolean;
  backgroundColor?: string;
  onMouseEnter?: () => void;
}

/* This is a presentational component - please keep all RF smarts in the outer DefaultNode component
 * We use this to render a node outside of RF.
 * */
export function ZapNodeContent(
  props: NodeProps<Node<ZapNodeData>> & ZapNodeContentProps,
) {
  const { isViewOnlyMode, onMouseEnter } = props;

  return (
    <AssetNodeSkeleton
      {...props}
      data={{
        ...props.data,
        color: props.data.color || DEFAULT_ZAP_NODE_COLOR,
      }}
      placeholder={isViewOnlyMode ? "" : "Describe your Zap"}
      iconName="miscBoltAltFill"
      backgroundColor={
        props.backgroundColor || DEFAULT_ZAP_NODE_BACKGROUND_COLOR
      }
      onMouseEnter={onMouseEnter}
    />
  );
}
